import { render, staticRenderFns } from "./DictForm.vue?vue&type=template&id=01d9d052&scoped=true"
import script from "./DictForm.vue?vue&type=script&lang=js"
export * from "./DictForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d9d052",
  null
  
)

export default component.exports